var React = require('react');

function Dropdown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M112.3 0.9c-1.3-1.3-3.4-1.3-4.7 0.1L56.5 53.3 5.7 1C4.4-0.3 2.3-0.3 1 0.9c-1.3 1.3-1.3 3.4-0.1 4.7l50.8 52.3c1.3 1.3 3 2.1 4.9 2.1 1.9 0 3.6-0.7 4.9-2.1l50.8-52.3C113.7 4.3 113.6 2.2 112.3 0.9z"}));
}

Dropdown.defaultProps = {"viewBox":"0 0 113.3 60"};

module.exports = Dropdown;

Dropdown.default = Dropdown;
